import { createIcon } from '@chakra-ui/react';

export const Email = createIcon({
  displayName: 'Email',
  viewBox: '0 0 64 64',
  path: (
    <>
      <circle id="Oval" cx="32" cy="32" r="32" fill="#d11947" />
      <g
        id="Envelope_Letter_Email_-_L"
        data-name="Envelope Letter Email - L"
        transform="translate(15.615 20)"
      >
        <path
          id="Envelope_Letter_Email_-_L-2"
          data-name="Envelope Letter Email - L"
          d="M33.32,10.422v-.054a.842.842,0,0,0-.156-.387l-.031-.038a.711.711,0,0,0-.146-.134h0a.648.648,0,0,0-.172-.086h-.047a.806.806,0,0,0-.224-.054H1.3a.8.8,0,0,0-.2.032H1.055a.648.648,0,0,0-.172.086h0a.711.711,0,0,0-.146.134L.706,9.96a.842.842,0,0,0-.156.387V32.869a.789.789,0,0,0,.755.8H32.544a.789.789,0,0,0,.776-.8V10.422Zm-2.629.849L20.106,22.32A4.379,4.379,0,0,1,16.924,23.7h0a4.389,4.389,0,0,1-3.192-1.376L3.153,11.271Zm1.083,19.642L24.245,23.04a.761.761,0,0,0-.761-.242.788.788,0,0,0-.567.577.817.817,0,0,0,.223.788l7.56,7.905H3.148l7.565-7.91a.82.82,0,0,0-.076-1.035.758.758,0,0,0-1-.088l-7.56,7.878V12.421L12.624,23.443a5.911,5.911,0,0,0,4.3,1.854h0a5.9,5.9,0,0,0,4.29-1.849L31.773,12.421Z"
          transform="translate(-0.55 -9.67)"
          fill="#fff"
        />
      </g>
    </>
  ),
});
